// Libraries
var React = require('react');
var extend = require('lodash/extend');
var $ = require('jquery');

// Assets
var PlaceholderImg = require('images/blankImgPlaceholder.png');

// Styles
require("slick-carousel/slick/slick.css");
require("slick-carousel/slick/slick-theme.css");
require('./Gallery.scss');

class GalleryModule extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			caption: this.props.data.slides[0].caption || "",
			preview: true
		}

		this.baseSettings = {
			dots: true,
			infinite: true,
			arrows: true,
			speed: 500,
			autoplay: false,
			slidesToShow: 1,
			slidesToScroll: 1
		};

		this.settings = null;
		this.mergeSettings(this.props.data.settings);
	}

	componentDidMount() {
		// this is here to prevent window being undefined when rendered server side
		require('slick-carousel');

		var gallery = $(this.imgGallery);
		gallery.not('.slick-initialized').slick(this.settings);

		gallery.on('beforeChange', (_event, _slick, _currentSlide, nextSlide) => {
			this.setState({ caption: this.props.data.slides[nextSlide].caption || "" });
		});
	}

	mergeSettings(settings) {
		if (settings != null) {
			this.settings = extend(this.baseSettings, this.props.data.settings);
		} else {
			this.settings = this.baseSettings;
		}
	}

	componentWillReceiveProps(nextProps) {
		this.mergeSettings(nextProps.data);
	}

	render() {
		return (
			<div className="Gallery" id={this.props.data.id || null}>
				<div className="Gallery__wrapper">
					<div className="Gallery__wrapper-inner" ref={g => this.imgGallery = g}>
						{this.props.data.slides.length > 0 && this.props.data.slides.map((item, index) => {
							return (
								<div className="Gallery__slide" key={index}>
									<img src={PlaceholderImg} data-src={item.image.smallUrl + '*,*' + item.image.mediumUrl + '*,*' + item.image.largeUrl + '*,*' + item.image.extraLargeUrl} alt={item.imageAltText || item.image.altText} />
									<div className="overlay"></div>
								</div>
							);
						})}
					</div>
					<div className="Gallery__background"></div>
				</div>
				<p className="Gallery__caption">{this.state.caption}</p>
			</div>
		)
	}
}

module.exports = GalleryModule;



// WEBPACK FOOTER //
// ./src/components/Gallery/GalleryModule.js